import { getSrc } from 'gatsby-plugin-image'
import React from 'react'
import { use404Image } from '../../hooks/404image'
import { useSiteMetadata } from '../../hooks/useSiteMetadata'

type MetaTag = {
  name: string
  content: string
}

type SeoPropTypes = {
  lang?: string
  imageUrl?: string | null
  title?: string | null
  description?: string | null
  meta?: Array<MetaTag>
  children?: React.ReactNode
}

const SEO = (props: SeoPropTypes): JSX.Element => {
  const fourZeroFourImageData = use404Image()
  const {
    title: defaultTitle,
    description: defaultDescription,
    author,
  } = useSiteMetadata()

  const {
    lang = 'en',
    title = 'Museum of Transport and Technology Auckland',
    description = defaultDescription ??
      'Museum of Transport and Technology Auckland',
    imageUrl = getSrc(fourZeroFourImageData.image)?.replace(
      /^\/\//,
      'https://',
    ),
    meta = [],
    children,
  } = props

  return (
    <>
      <title>
        {title} | {defaultTitle}
      </title>
      <script
        src='https://cdn.userway.org/widget.js'
        data-account={process.env.GATSBY_USER_WAY_ID}
      />
      <meta name='description' content={description} />
      <meta name='image' content={imageUrl ?? undefined} />
      <meta name='author' content={author} />
      <meta name='og:title' content={title ?? undefined} />
      <meta name='og:description' content={description} />
      <meta name='fb:app_id' content='270315390704945' />
      {/* TODO: Add SEO Keyword support <meta name="keywords" content={tags} /> */}
      <meta name='og:type' content='website' />
      <meta name='og:url' content={imageUrl ?? undefined} />
      <meta name='og:image' content={imageUrl ?? undefined} />
      <meta name='twitter:card' content='summary' />
      <meta name='twitter:creator' content={author} />
      <meta name='twitter:title' content={title ?? undefined} />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:image' content={imageUrl ?? undefined} />
      {meta}
      {children}
      <html lang={lang} />
    </>
  )
}

export default SEO
